app.controller('appCtrl', [
    '$scope', 'appService', function ($scope, appService) {
		$scope.style = {};

		if (appService.isApp) {
			$scope.style = {
				"user-select": "none",
			};
		}
   }
]);